import React from 'react'
import propTypes from 'prop-types'

import styles from './styles.scss'

const Checkbox = ( { id, label, disabled, checked, onChange } ) => (
  <div className={styles['wrapper-checkbox']}>
    <input
      id={id}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={( e ) => onChange( e.target.checked )}
    />
      
    <label htmlFor={id}>{label}</label>
  </div>
)

Checkbox.propTypes = {
  id: propTypes.string,
  label: propTypes.string,
  checked: propTypes.bool,
  disabled: propTypes.bool,
  onChange: propTypes.func
}

Checkbox.defaultProps = {
  id: 'checkbox',
  label: 'Toggle something',
  checked: false,
  disabled: false,
  onChange: () => {}
}

export default Checkbox


// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js